/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetSeatsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createUpdateSeatsResponseFromDiscriminatorValue, serializeUpdateSeatsRequest, serializeUpdateSeatsResponse, type ErrorResponse, type GetSeatsResponse, type InternalErrorResponse, type UpdateSeatsRequest, type UpdateSeatsResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/seats
 */
export interface SeatsRequestBuilder extends BaseRequestBuilder<SeatsRequestBuilder> {
    /**
     * Sales rep seats the organization pays for, and how many are in use.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetSeatsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetSeatsResponse | undefined>;
    /**
     * Changes the number of sales rep seats the organization pays for. A reduction below the number of active reps is refused; deactivate reps first.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<UpdateSeatsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     patch(body: UpdateSeatsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<UpdateSeatsResponse | undefined>;
    /**
     * Sales rep seats the organization pays for, and how many are in use.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Changes the number of sales rep seats the organization pays for. A reduction below the number of active reps is refused; deactivate reps first.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(body: UpdateSeatsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SeatsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/seats";
/**
 * Metadata for all the requests in the request builder.
 */
export const SeatsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SeatsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetSeatsResponseFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: SeatsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createUpdateSeatsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateSeatsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
